// App principal com roteamento
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from './contexts/ThemeContext';
import { AuthProvider } from './contexts/AuthContext';
import { EmpresaProvider } from './contexts/EmpresaContext';
import { ProtectedRoute } from './components/auth/ProtectedRoute';
import { MainLayout } from './components/layout/MainLayout';
import { AdminLayout } from './components/layout/AdminLayout';
import { LandingPage } from './pages/LandingPage';
import { Login } from './pages/Login';
import { Dashboard } from './pages/Dashboard';
import { Emissao } from './pages/Emissao';
import { NFe } from './pages/Emissao/NFe';
import { NFSe } from './pages/Emissao/NFSe';
import { NFCe } from './pages/Emissao/NFCe';
import { Cadastros } from './pages/Cadastros';
import { Clientes } from './pages/Cadastros/Clientes';
import { Fornecedores } from './pages/Cadastros/Fornecedores';
import { Produtos } from './pages/Cadastros/Produtos';
import { Servicos } from './pages/Cadastros/Servicos';
import { Empresa } from './pages/Cadastros/Empresa';
import { Transportadora } from './pages/Cadastros/Transportadora';
import { Consultas } from './pages/Consultas';
import { Relatorios } from './pages/Relatorios';
import { Configuracoes } from './pages/Configuracoes';
import { Suporte } from './pages/Suporte';
import { NotaSingle } from './pages/Notas/Single';
import { AdminDashboard } from './pages/Admin/Dashboard';
import { Usuarios } from './pages/Admin/Usuarios';
import { Assinaturas } from './pages/Admin/Assinaturas';
import { AdminEmpresas } from './pages/Admin/Empresas';
import { Contas } from './pages/Admin/Contas';
import { Pacotes } from './pages/Admin/Pacotes';
import { AdminConfiguracoes } from './pages/Admin/Configuracoes';
import { Checkout } from './pages/Checkout';

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <EmpresaProvider>
          <BrowserRouter>
            <Routes>
              {/* Landing Page */}
              <Route path="/" element={<LandingPage />} />

              {/* Login */}
              <Route path="/login" element={<Login />} />
              <Route path="/checkout" element={<Checkout />} />

              {/* Aplicação Interna - Protegida */}
              <Route path="/app" element={<ProtectedRoute><MainLayout /></ProtectedRoute>}>
                <Route index element={<Dashboard />} />

                {/* Emissão */}
                <Route path="emissao" element={<Emissao />} />
                <Route path="emissao/nfe" element={<NFe />} />
                <Route path="emissao/nfse" element={<NFSe />} />
                <Route path="emissao/nfce" element={<NFCe />} />

                {/* Cadastros */}
                <Route path="cadastros" element={<Cadastros />} />
                <Route path="cadastros/clientes" element={<Clientes />} />
                <Route path="cadastros/fornecedores" element={<Fornecedores />} />
                <Route path="cadastros/produtos" element={<Produtos />} />
                <Route path="cadastros/servicos" element={<Servicos />} />
                <Route path="cadastros/empresa" element={<Empresa />} />
                <Route path="cadastros/transportadora" element={<Transportadora />} />

                {/* Consultas e Relatórios */}
                <Route path="consultas" element={<Consultas />} />
                <Route path="notas/:id" element={<NotaSingle />} />
                <Route path="relatorios" element={<Relatorios />} />
                <Route path="configuracoes" element={<Configuracoes />} />
                <Route path="suporte" element={<Suporte />} />
              </Route>

              {/* FA1 Admin - Protegida */}
              <Route path="/app/admin" element={<ProtectedRoute><AdminLayout /></ProtectedRoute>}>
                <Route index element={<AdminDashboard />} />
                <Route path="usuarios" element={<Usuarios />} />
                <Route path="assinaturas" element={<Assinaturas />} />
                <Route path="empresas" element={<AdminEmpresas />} />
                <Route path="contas" element={<Contas />} />
                <Route path="pacotes" element={<Pacotes />} />
                <Route path="configuracoes" element={<AdminConfiguracoes />} />
              </Route>
            </Routes>
          </BrowserRouter>
        </EmpresaProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;